import { inject, Injectable, Signal } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { CurrencyInfo } from '@app/generated-api';
import { CurrencyService as GeneratedCurrencyService } from '@app/generated-api/services/CurrencyService';
import { computedAllDefined, computedAllDefinedNotNull } from '@app/v2/utils/signal-utils';
import { MdsOption } from '@medpacesoftwaredevelopment/designsystem';
@Injectable({
    providedIn: 'root',
})
export class CurrencySignalService {
    generatedCurrencyService = inject(GeneratedCurrencyService);
    // invoked on service initialization to cache the currencies for future use in the app
    readonly currencies = rxResource({
        stream: () => this.generatedCurrencyService.currencyGet(),
    });
    readonly currenciesAsMdsOptions = computedAllDefined({ currencies: this.currencies.value }, ({ currencies }) => {
        return currencies.map<MdsOption<CurrencyInfo>>((c) => ({ value: c, viewValue: c.isocode }));
    });
    getCurrencyByCodeOrName(isocode: Signal<string | null | undefined>) {
        return computedAllDefinedNotNull(
            { currencies: this.currencies.value, isocode: isocode },
            ({ currencies, isocode }) => {
                const isocodeLowerCase = isocode.toLowerCase();
                return currencies.find((c) => c.isocode.toLowerCase() === isocodeLowerCase);
            }
        );
    }
}
